import React, { useEffect, useState } from "react";
import { Rocket } from "lucide-react";
import api from "../lib/api";
import { findLaunchComps } from "../lib/launch";
import { CompetitionCard } from "./CompetitionCard";
import { SectionTitle } from "./Neon";

// Public section showing all Launch Day Special Draws. Entrants can join these
// before the site officially goes live; they are drawn on launch night.
export const LaunchDraws = () => {
  const [draws, setDraws] = useState([]);

  useEffect(() => {
    api.get("/competitions").then(({ data }) => setDraws(findLaunchComps(data))).catch(() => {});
  }, []);

  if (!draws.length) return null;

  return (
    <section data-testid="launch-draws-section" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
      <div className="flex items-center gap-2">
        <Rocket className="h-5 w-5 text-[var(--neon-gold)]" />
        <SectionTitle accent="gold">Launch Day Special Draws</SectionTitle>
      </div>
      <p className="mt-1 text-sm text-[var(--text-muted)]">
        Get in early — enter these exclusive launch competitions now, before we go live. Winners are drawn LIVE when we launch.
      </p>
      <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {draws.map((c) => <CompetitionCard key={c.id} comp={c} />)}
      </div>
    </section>
  );
};
